import { render, staticRenderFns } from "./email-login-dialog.vue?vue&type=template&id=0159a7fd&scoped=true"
import script from "./email-login-dialog.vue?vue&type=script&lang=js"
export * from "./email-login-dialog.vue?vue&type=script&lang=js"
import style0 from "./email-login-dialog.vue?vue&type=style&index=0&id=0159a7fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0159a7fd",
  null
  
)

export default component.exports